import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CompanyListService from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateClient from '../Client/CreateClient';
import useFormSubmission from '../../../Auth/Controller/AuthController';
import { SidebarContext } from '../../../Layout/SidebarContext';
import ModuleService from '../../../Setup/controller/ModuleController/ModuleController';
import UserService from "../../../Setup/controller/UserController/UserController";
import 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-buttons';
import 'datatables.net-buttons-bs5';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import $ from 'jquery';
import Swal from 'sweetalert2';
import Common from '../../../Common/Common';
import FormService from "../../../Setup/controller/FormController/FormController";
import ClientLanguages from "../../../Setup/controller/LanguageController/LanguageController";
import HelpLinkService from "../../../SuperAdmin/Controller/Configuration/HelpLinkController";
import { logout } from "../../../Auth/Controller/AuthController";
function JobSetting() {
    const [activeTab, setActiveTab] = useState('projects'); // Initially set to 'projects'
    const navigate = useNavigate();
    const { updateSidebarModules } = useContext(SidebarContext);
    const { theme, toggleTheme } = useContext(ThemeContext);
    const [companyList, setCompanies] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentClient, setCurrentClient] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const tableRef = useRef();

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    };



    const fetchClients = async () => {
        try {
            const CompanyList = await CompanyListService.GetAllCompanies(() => navigate('/'));
            debugger;
            setCompanies(CompanyList);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    useEffect(() => {
        fetchClients();
    }, []);

    const today = new Date();
    const oneMonthAhead = new Date();
    oneMonthAhead.setMonth(today.getMonth() + 1);

    const activeCompanies = companyList.filter(company => new Date(company.EndDate) >= oneMonthAhead);
    const expiredCompanies = companyList.filter(company => new Date(company.EndDate) < today);
    const gettingExpiredCompanies = companyList.filter(company => new Date(company.EndDate) >= today && new Date(company.EndDate) < oneMonthAhead);

    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/ClientList";


    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');

    const [tableInitialized, setTableInitialized] = useState(false);



    const handleSubmit = useFormSubmission();

    let accordTheme = "accordion-header-light";

    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }






    const handleCreateClientClick = () => {
        setCurrentClient(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setCurrentClient(null);
        setIsModalOpen(false);
    };

    const handleSuccess = async () => {
        await fetchClients();
        setCurrentClient(null);
        setIsModalOpen(false);
    };


    const handleEditClick = (company) => {
        setCurrentClient(company);
        setIsModalOpen(true);
    };


    const handleDeleteClick = async (ID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await CompanyListService.DeleteClient(ID);
                    await fetchClients();
                } catch (error) {
                    console.error('Error deleting client:', error);
                }
            }
        });
    };
    const handleActivateClick = async (ID) => {
        Swal.fire({
            title: '',
            text: "Are you sure to re-active the company account.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await CompanyListService.SetActiveClient(ID);
                    await fetchClients();
                } catch (error) {
                    console.error('Error deleting client:', error);
                }
            }
        });
    };

    const fetchModules = async () => {
        const modules = await ModuleService.GetAllModules(() => navigate('/'), "en");
        updateSidebarModules(modules);
    };
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const handleLoginClick = async (username, password, ClientID) => {
        debugger;
        await logout();
        const formData = { UserName: username, Password: password, IsAdminLogin: "1", ClientID: ClientID };
        localStorage.setItem('CompanyID', ClientID);
        //  fetchModules();

        const response = await handleSubmit(null, formData, "", setErrors, setErrorMessage);
        if (response.data.multipleCompanies === false) {
            localStorage.setItem('token', response.data.companies[0].token); // Access token
            localStorage.setItem('refreshToken', response.data.companies[0].refreshToken); // Refresh token
            localStorage.setItem('CompanyID', response.data.companies[0].HostCompanyID);
            localStorage.setItem('RoleID', response.data.companies[0].RolesID);
            localStorage.setItem('UserID', response.data.companies[0].UserID);
            localStorage.setItem('DisplayName', response.data.companies[0].DisplayName);
            localStorage.setItem('Email', response.data.companies[0].Email);
            localStorage.setItem('CompanyName', response.data.companies[0].CompanyName);
            localStorage.setItem('Address1', response.data.companies[0].Address1);
            localStorage.setItem('ContractPrefix', response.data.companies[0].ContractPrefix);
            localStorage.setItem('AllowedUsers', response.data.companies[0].AllowedUsers);
            const ModuleList = await ModuleService.GetAllModules(redirectCallback, "en");
            localStorage.setItem('ModuleList', JSON.stringify(ModuleList));
            const FormList = await FormService.GetAllForms(redirectCallback);
            localStorage.setItem('FormList', JSON.stringify(FormList));
            const clientLanguage = await ClientLanguages.GetClientLanguage(redirectCallback, response.data.companies[0].HostCompanyID);
            localStorage.setItem('ClientLanguages', JSON.stringify(clientLanguage));
            const HelpLink = await HelpLinkService.GetAllHelpLinks(redirectCallback);
            if (HelpLink && HelpLink[0]) {
                localStorage.setItem('HelpLink', HelpLink[0].HelpLink);
            }
            localStorage.setItem('IsAdminLogin', "1");

            const user = await UserService.IsMultipleCompanies(response.data.companies[0].Email);
            if (user.length > 1) {
                localStorage.setItem('Companies', JSON.stringify(user));
                localStorage.setItem('MultipleCompanies', "1");
            }
            else {
                localStorage.setItem('Companies', JSON.stringify(user));
                localStorage.setItem('MultipleCompanies', "0");
            }
            let Isexpired = "0";
            const companySetup = await CompanyListService.GetCompanyByID(redirectCallback, response.data.companies[0].HostCompanyID);
            if (companySetup.length > 0 && companySetup[0].DaysLeft < 1) {
                Isexpired = "1";
            }
           localStorage.setItem('LicenseExpired', Isexpired);
            fetchModules();

            navigate('/Dashboard');
        }
    };
    return (
        <div>
            <Common showClientButton={'yes'} handleCreateClientClick={handleCreateClientClick} />
            <div className="main-content-header">
                <h1>Client List</h1>
            </div>

            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="wrapper tabs-style-two">
                                <ul className="nav nav-tabs list">
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeTab === 'projects' ? 'active' : ''}`} onClick={() => setActiveTab('projects')}>Active Companies</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeTab === 'projectMembers' ? 'active' : ''}`} onClick={() => setActiveTab('projectMembers')}>Expired Companies</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeTab === 'projectCategory' ? 'active' : ''}`} onClick={() => setActiveTab('projectCategory')}>Expiring Soon</a>
                                    </li>
                                </ul>

                                <div className="tab-content">
                                    {[['projects', activeCompanies], ['projectMembers', expiredCompanies], ['projectCategory', gettingExpiredCompanies]].map(([tab, companies]) => (
                                        activeTab === tab && (
                                            <div className="tab-pane fade show active" key={tab}>
                                                <div className="table-responsive">
                                                    <table className="table m-0 table-hover" ref={tableRef} style={{ minHeight: "200px" }}>
                                                        <thead>
                                                            <tr>
                                                                <th className="no-wrap">Client Name</th>
                                                                <th className="no-wrap">Subscription Date</th>
                                                                <th className="no-wrap">Expiry Date</th>
                                                                <th className="no-wrap">Contact</th>
                                                                <th className="no-wrap">VAT Registration</th>
                                                                <th className="no-wrap">User Name</th>
                                                                <th className="no-wrap">Password</th>
                                                                <th className="no-wrap">Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {companies.length > 0 ? (
                                                                companies.map((company) => {
                                                                    const expiryDate = new Date(company.EndDate);
                                                                    let textColor = "white"; // Default background
                                                                    if (expiryDate < today) {
                                                                        textColor = "#f5dede"; // Expired
                                                                    } else if (expiryDate < oneMonthAhead) {
                                                                        textColor = "#f7d494"; // Expiring soon
                                                                    }
                                                                    if (company.IsActive === "0" || company.IsActive === 0) {
                                                                        textColor = "#d3d3d3";
                                                                    }

                                                                    return (
                                                                        <tr key={company.ID} style={{ background: textColor }}>
                                                                            <td className="no-wrap" title={company.CompanyName}>
                                                                                {company.CompanyName && company.CompanyName.length > 12
                                                                                    ? `${company.CompanyName.substring(0, 12)}...`
                                                                                    : company.CompanyName}
                                                                            </td>
                                                                            <td className="no-wrap">{formatDate(company.StartDate)}</td>
                                                                            <td className="no-wrap">{formatDate(company.EndDate)}</td>
                                                                            <td className="no-wrap" title={company.Contact}>
                                                                                {company.Contact && company.Contact.length > 12
                                                                                    ? `${company.Contact.substring(0, 12)}...`
                                                                                    : company.Contact}
                                                                            </td>
                                                                            <td className="no-wrap" title={company.VATReg}>
                                                                                {company.VATReg && company.VATReg.length > 12
                                                                                    ? `${company.VATReg.substring(0, 12)}...`
                                                                                    : company.VATReg}
                                                                            </td>
                                                                            <td className="no-wrap">{company.UserName}</td>
                                                                            <td className="no-wrap">{company.UserPassword}</td>
                                                                            <td>
                                                                                <div className="dropdown">
                                                                                    <button
                                                                                        className="btn btn-primary dropdown-toggle btnActions"
                                                                                        type="button"
                                                                                        id="dropdownMenuButton"
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                    >
                                                                                        Actions
                                                                                    </button>
                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                                        <li>
                                                                                            <button className="dropdown-item" onClick={() => handleEditClick(company)}>Edit</button>
                                                                                        </li>
                                                                                        {company.IsActive === 0 ? (
                                                                                            <li>
                                                                                                <button
                                                                                                    className="dropdown-item"
                                                                                                    onClick={() => handleActivateClick(company.CoSetupID)}
                                                                                                >
                                                                                                    Set Active
                                                                                                </button>
                                                                                            </li>
                                                                                        ) : (
                                                                                            <li>
                                                                                                <button
                                                                                                    className="dropdown-item"
                                                                                                    onClick={() => handleDeleteClick(company.CoSetupID)}
                                                                                                >
                                                                                                    Delete
                                                                                                </button>
                                                                                            </li>
                                                                                        )}
                                                                                        <li>
                                                                                            <button className="dropdown-item"
                                                                                                onClick={() => handleLoginClick(company.Email, company.UserPassword, company.CoSetupID)}
                                                                                                disabled={company.IsAdminAllowed === 0 || company.CustomerID === "0"}
                                                                                                style={{
                                                                                                    backgroundColor: company.IsAdminAllowed === 0 ? 'rgb(217 227 217)' : 'white', // Background color based on IsActive
                                                                                                    opacity: company.IsAdminAllowed === 0 ? 0.5 : 1, // Reduce opacity for a disabled look
                                                                                                }}
                                                                                            >Login</button>
                                                                                        </li>
                                                                                        <li>
                                                                                            <Link className="dropdown-item" to={`/AssignModule?ClientID=${company.CoSetupID}`}>
                                                                                                Assign Modules
                                                                                            </Link>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="8">No data available</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                    {isModalOpen && (
                                                        <CreateClient company={currentClient} onClose={handleCloseModal} onSuccess={handleSuccess} />
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JobSetting;
